import { ApiResponse } from "@/interfaces/api-response";
import { FontCategory } from "@/interfaces/font.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "font-categories";

const createOne = async (data: Partial<FontCategory>) => {
  const response = await apiClient.post<ApiResponse<FontCategory>>(
    `/${SERVICE_ENDPOINT}`,
    data,
  );
  return response.data;
};

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  parentId?: string;
}) => {
  const response = await apiClient.get<ApiResponse<FontCategory[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<FontCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<FontCategory>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<FontCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<FontCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const fontCategoryApi = {
  createOne,
  getMany,
  getOneById,
  updateOneById,
  deleteOneById,
};

export default fontCategoryApi;
